import { XHRRequestCanceler } from "../../../Libs/xhr/XHRRequestCanceler";
import { IWorkersDataService, WorkersDataServiceName } from "../../DataServices/WorkersDataService";
import {
  WorkerNewPasswordResponse,
  WorkersDetailsResponse,
  WorkersListSummaryResponse,
} from "../../Models/Workers/Workers";
import { BaseReduxService, IBaseReduxService } from "../Api/BaseReduxService";
import { IoC } from "../ServicesContainer";
import { WorkersActions } from "./WorkersActions";

export interface IWorkersService extends IBaseReduxService {
  loadWorkers: (cts: XHRRequestCanceler, workerState?: boolean) => Promise<WorkersListSummaryResponse>;

  getWorkerDetails: (workerId: string) => Promise<WorkersDetailsResponse>;

  getWorkerNewPassword: (workerId: string) => Promise<WorkerNewPasswordResponse>;

  updateWorker: (workerId: string, enabled: boolean, cts?: XHRRequestCanceler) => Promise<WorkersDetailsResponse>;
}

class WorkersService extends BaseReduxService implements IWorkersService {
  private readonly workersDataService: IWorkersDataService;

  constructor() {
    super();
    this.workersDataService = IoC.get<IWorkersDataService>(WorkersDataServiceName);
  }

  loadWorkers = async (cts: XHRRequestCanceler): Promise<WorkersListSummaryResponse> => {
    try {
      const response = await this.workersDataService.getWorkers(cts);
      this.dispatch(WorkersActions.setWorkersInitialized(true));
      this.dispatch(WorkersActions.setWorkers(response.data));
      return Promise.resolve(response);
    } catch (error) {
      this.dispatch(WorkersActions.setWorkersInitialized(true));
      this.dispatch(WorkersActions.setWorkers([]));
      return Promise.reject(error);
    }
  };

  getWorkerNewPassword = async (workerId: string): Promise<WorkerNewPasswordResponse> => {
    try {
      const response = await this.workersDataService.getWorkerNewPassword(workerId);
      return Promise.resolve(response);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  updateWorker = async (
    workerId: string,
    enabled: boolean,
    cts?: XHRRequestCanceler
  ): Promise<WorkersDetailsResponse> => {
    try {
      const response = await this.workersDataService.updateWorker(workerId, enabled, cts);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  };

  getWorkerDetails = async (workerId: string): Promise<WorkersDetailsResponse> => {
    try {
      const response = await this.workersDataService.getWorkerDetails(workerId);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

const WorkersServiceName = "WorkersService";
export { WorkersService, WorkersServiceName };
